import DAC7 from 'pages/my/settings/profile/DAC7';

export default DAC7;
